<script lang="ts">
  import Modal from '../ui/Modal.svelte';
  import FormField from '../ui/FormField.svelte';
  import Button from '../ui/Button.svelte';
  import { API_KEY_SCOPES, type ApiKeyScope } from '../../lib/types';

  type Props = {
    onClose: () => void;
    onCreate: (name: string, scopes: ApiKeyScope[]) => void;
  };

  let { onClose, onCreate }: Props = $props();

  let name = $state('');
  let selectedScopes = $state<ApiKeyScope[]>([]);
  let error = $state('');

  let isValid = $derived(name.trim().length > 0 && selectedScopes.length > 0);

  function toggleScope(scopeId: ApiKeyScope) {
    if (selectedScopes.includes(scopeId)) {
      selectedScopes = selectedScopes.filter(s => s !== scopeId);
    } else {
      selectedScopes = [...selectedScopes, scopeId];
    }
  }

  function handleSubmit(e: Event) {
    e.preventDefault();

    if (!name.trim()) {
      error = 'Please enter a key name';
      return;
    }

    if (selectedScopes.length === 0) {
      error = 'Please select at least one permission';
      return;
    }

    error = '';
    onCreate(name.trim(), selectedScopes);
  }
</script>

<Modal isOpen={true} title="Create API Key" onClose={onClose}>
  <form onsubmit={handleSubmit}>
    {#if error}
      <div class="error-message">{error}</div>
    {/if}

    <FormField label="Key Name" required>
      <input
        type="text"
        bind:value={name}
        placeholder="e.g. Production API Key"
      />
    </FormField>

    <FormField label="Permissions" required hint="Select which resources this key can access">
      <div class="scope-grid">
        {#each API_KEY_SCOPES as scope}
          <label class="checkbox-item" class:checked={selectedScopes.includes(scope.id)}>
            <input
              type="checkbox"
              checked={selectedScopes.includes(scope.id)}
              onchange={() => toggleScope(scope.id)}
            />
            {scope.label}
          </label>
        {/each}
      </div>
    </FormField>

    <div class="form-actions">
      <Button variant="secondary" onclick={onClose}>Cancel</Button>
      <Button type="submit" variant="primary" disabled={!isValid}>Create Key</Button>
    </div>
  </form>
</Modal>

<style>
  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .error-message {
    background: #fee;
    border: 1px solid #fcc;
    color: #c33;
    padding: 0.75rem;
    border-radius: 6px;
    font-size: 0.875rem;
  }

  input[type="text"] {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-size: 0.9375rem;
    font-family: inherit;
    transition: border-color 0.2s;
  }

  input[type="text"]:focus {
    outline: none;
    border-color: #667eea;
  }

  .scope-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 0.5rem;
  }

  @media (max-width: 480px) {
    .scope-grid {
      grid-template-columns: 1fr;
    }
  }
</style>
